import { useEffect, useState } from "react"
import Button from "../../../../common/Button"
import { useDispatch, useSelector } from "react-redux"
import { caseActions } from "../../../../../store/case"
import { caseQuickUpdate } from "../../../../../lib/fetchApi"
import { notificationActions } from "../../../../../store/notifications"
import CheckboxCell from "../../../../common/interactive/CheckboxCell"
import { frontendOptions } from "../../../../../lib/systemData"
import DefaultUpdater from "../../../../common/DefaultUpdater"
import RadioField from "../../../../common/interactive/RadioField"
import { formatApiDateEnUs, toApiDateYmd } from "../../../../../lib/dateParsing"
import { namesMatchIgnoreCase } from "../../../../../lib/patientName"

const atFaultmatch = {
    'false': 1,
    'true': 2,
}

function isCheckboxChecked(value) {
    if (value === true || value === 1 || value === '1' || value === 'true') {
        return true
    }
    if (value === false || value === 0 || value === '0' || value === 'false' || value == null || value === '') {
        return false
    }
    return Boolean(value)
}

export default function PoliceReportVerificationBox({classes, label, reportValue, eCMValue, identifier, caseId,isDate, isInsurance, checkForInsurance, type, at_fault_custom_check, isEditable, fieldType, isProcessed, ignoreCase}) {

    const dispatch = useDispatch()
    const [isDifferent, setIsDifferent] = useState(false)
    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)

    const isDateField = isDate != null && isDate !== ''
    const reportDisplay = isDateField ? formatApiDateEnUs(reportValue) : reportValue
    const eCMDisplay = isDateField ? formatApiDateEnUs(eCMValue) : eCMValue

    const getReportCopyValue = () => {
        if (at_fault_custom_check) {
            return reportValue != null && reportValue !== '' ? atFaultmatch[reportValue] : null
        }
        if (isDate != null && isDate !== '') {
            return toApiDateYmd(isDate)
        }
        return isDate ?? reportValue
    }

    const canCopyReportValue = () => {
        const value = getReportCopyValue()
        return value != null && value !== ''
    }

    const renderCopyStatus = () => {
        if (!isDifferent) {
            return <i className='ti ti-checks' style={{color: 'var(--green1)'}}></i>
        }
        if (!canCopyReportValue() || isProcessed) {
            return (
                <i
                    className='ti ti-transfer'
                    style={{color: 'var(--subtitle)', opacity: 0.5, cursor: 'not-allowed'}}
                    title={isProcessed ? 'Report has been marked as processed' : 'No value available to copy from police report'}
                ></i>
            )
        }
        return (
            <Button btnStyle={'btn_simple'} title={'Copy information to eCM'} click={updateHandlerInput} isLoading={loading} loaderType={'dark'}>
                <i className='ti ti-transfer'></i>
            </Button>
        )
    }

    const updateHandlerInput = async () => {
        if (!canCopyReportValue() || isProcessed) {
            return
        }

        setLoading(true)

        try {
            let reqBody
            let valueToUpdate = getReportCopyValue()
            if (identifier.subSet) {
                reqBody = {
                    type: identifier.type,
                    type_id: identifier.type_id,
                    fields: {
                        [identifier.subSet]: {
                            [identifier.field]: valueToUpdate
                        }
                    }
                }
            } else {
                reqBody = {
                    type: identifier.type,
                    type_id: identifier.type_id,
                    fields: {
                        [identifier.field]: valueToUpdate
                    }
                }
            }

            let update = await caseQuickUpdate(userToken, caseId, reqBody, null, true)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else if (!update?.staleResponse) {
                dispatch(notificationActions.setError({errorMessage: `Your changes have been successfully saved to the case.`, type: 'success'}))

                if (identifier.folder == 'patient') {
                    if (update?.caseData?.patient) {
                        dispatch(caseActions.batchUpdate({ patient: update.caseData.patient }))
                    } else if (identifier.subSet) {
                        dispatch(caseActions.batchUpdate({
                            patient: {
                                [identifier.subSet]: {
                                    [identifier.field]: valueToUpdate,
                                },
                            },
                        }))
                    } else {
                        dispatch(caseActions.batchUpdate({
                            patient: {
                                [identifier.field]: valueToUpdate,
                            },
                        }))
                    }
                } else if (identifier.folder == 'police_reports' || identifier.folder == 'case_negotiation' || identifier.folder == 'additional' || identifier.folder == 'crime_victim' || identifier.folder == 'worker_comp' || identifier.folder == 'case' || identifier.folder == 'aica_department_status' || identifier.folder == 'selfpay') {
                    let dispatchObj = {
                        folder: identifier.folder,
                        item: {
                            fields: [
                                {
                                    field: identifier.field,
                                    value: valueToUpdate
                                },
                            ]
                        }
                    }

                    dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
                } else {
                    let dispatchObj = {
                        folder: identifier.folder,
                        item: {
                            itemId: identifier.type_id,
                            fields: [
                                {
                                    field: identifier.field,
                                    value: valueToUpdate
                                },
                            ]
                        }
                    }

                    dispatch(caseActions.modifyActiveCaseMultiple(dispatchObj))
                }
            }
        } finally {
            setLoading(false)
        }
    }

    

    useEffect(() => {
        if (at_fault_custom_check) {

            if(atFaultmatch[reportValue] == eCMValue) {
                setIsDifferent(false)
            } else {
                setIsDifferent(true)
            }
        } else if (isDateField) {
            setIsDifferent(toApiDateYmd(reportValue) != toApiDateYmd(eCMValue))
        } else if (ignoreCase) {
            setIsDifferent(!namesMatchIgnoreCase(reportValue, eCMValue))
        } else {
            setIsDifferent(reportValue != eCMValue)
        }
    }, [reportValue, eCMValue, at_fault_custom_check, isDateField, ignoreCase])

    const renderECMField = () => {
        if (isProcessed) {
            if (at_fault_custom_check) {
                return (
                    <RadioField
                        fields={frontendOptions()?.AT_Fault_Radio}
                        name={identifier.field}
                        defaultChecked={eCMValue}
                        identifier={identifier}
                        normalSize={true}
                        isDisable={true}
                    />
                )
            }
            if (type === 'checkbox') {
                return <CheckboxCell checked={isCheckboxChecked(eCMValue)} isDisabled={true} />
            }
            return <div className={classes.input}>{eCMDisplay}</div>
        }
        if (!at_fault_custom_check) {
            return (
                <DefaultUpdater
                    type={'checkbox'}
                    value={eCMValue}
                    label={label}
                    name={identifier.field}
                    identifier={identifier}
                    extraOptions={{ isDisabled: !isEditable, direction: 'reverse' }}
                />
            )
        }
        return (
            <DefaultUpdater
                type={'radio'}
                options={frontendOptions()?.AT_Fault_Radio}
                value={eCMValue}
                label={label}
                name={identifier.field}
                identifier={identifier}
                extraOptions={{ isDisabled: !isEditable, isDisable: !isEditable }}
            />
        )
    }

    return <div className={classes.group_row}>
        {type == 'checkbox' && <>
            <div className={classes.label}>
                <span>{label}</span>
            </div>
            <div className={classes.value}>
                <CheckboxCell checked={isCheckboxChecked(reportValue)} isDisabled={true}/>
            </div>
            {checkForInsurance ? <>
                {isInsurance ? <>
                    <div className={classes.status}>
                        {renderCopyStatus()}
                        
                    </div>
                </> : <>
                    <div className={classes.status}>
                        <i className='ti ti-ban' style={{color: 'var(--red1)'}} title='No insurance found'></i>
                    </div>
                </>}
            
            </> : <>
                <div className={classes.status}>
                    {renderCopyStatus()}
                    
                </div>
            </>}

            <div className={classes.value}>
                {renderECMField()}
            </div>
        </>}

        {type != 'checkbox' && <>
            <div className={classes.label}>
                <span>{label}</span>
            </div>
            <div className={classes.value}>
                <div className={`${classes.input} ${isDifferent ? classes.input_danger : ''}`}>{reportDisplay}</div>
            </div>

            {checkForInsurance ? <>
                {isInsurance ? <>
                    <div className={classes.status}>
                        {renderCopyStatus()}
                        
                    </div>
                </> : <>
                    <div className={classes.status}>
                        <i className='ti ti-ban' style={{color: 'var(--red1)'}} title='No insurance found'></i>
                    </div>
                </>}
            
            </> : <>
                <div className={classes.status}>
                    {renderCopyStatus()}
                    
                </div>
            </>}
            
            <div className={classes.value}>
                {!isEditable || isProcessed ? <div className={classes.input}>{eCMDisplay}</div> : 
                
                <DefaultUpdater type={fieldType} value={eCMValue} label={label} name={identifier.field} identifier={identifier} extraOptions={{isDisabled: isProcessed}}/> }
            </div>
        </>}
    </div>
}